import React, { useContext, useMemo } from 'react';
import { createUseStyles, useTheme, Text, Divider, Link, Icon } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import { CopilotChat } from 'shards/Copilot';
import CopilotDisclaimer from 'shards/Copilot/CopilotDisclaimer';
import { CopilotContext } from '../../Context';
import CopilotSidebarTabHeader from '../components/CopilotSidebarTabHeader';

import styles from './styles';

const useStyles = createUseStyles(styles, 'CopilotSidebarChat');

const CopilotSidebarChatTab = () => {
    const { t } = useWeb5Context();
    const theme = useTheme();
    const classes = useStyles();

    const { chats, defaultAgent } = useContext(CopilotContext);
    const { activeAgent } = chats?.['copilot-sidebar'] ?? {};

    const { name: featureName } = useMemo(() => {
        return activeAgent || defaultAgent || {};
    }, [activeAgent, defaultAgent]);

    const chatProps = useMemo(
        () => ({
            chatId: 'copilot-sidebar',
            className: classes.chat,
            session: {
                features: [featureName],
            },
            defaultFirstInteraction: { text: t('label_copilot_default_greeting') },
            enableVoiceInput: true,
        }),
        [classes.chat, featureName, t],
    );

    return (
        <div className={classes.root}>
            <div className={classes.chatContainer}>
                <CopilotSidebarTabHeader title={t('label_copilot_tab_chat')} />
                <CopilotChat {...chatProps} />
            </div>
            <CopilotDisclaimer className={classes.footer} />
        </div>
    );
};

export default CopilotSidebarChatTab;
